import { useMemo } from "react";
import { useObservable } from "hooks";
import { topicService } from "services";

const useTopic = () => {
  const topics = useObservable(topicService.topics$);
  const current = useObservable(topicService.current$);
  const queries = useObservable(topicService.queries$);
  const actions = useMemo(
    () => ({
      create: topicService.create,
      current: topicService.current,
      fetch: topicService.fetch,
      edit: topicService.edit,
      delete: topicService.delete,
    }),
    []
  );
  return { topics, current, queries, actions };
};

export { useTopic };
